import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'run_notice_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      iconStyleList: ['lingdang', 'lingdang-xianxing', 'xiaoxi1', 'xiaoxi2', 'yinliang-F', 'yinliang-L'],
      rules: {
        background_color: [{
          required: true,
          message: '背景色不可为空'
        }],
        font_size: [{
          required: true,
          message: '字号不可为空'
        }],
        font_color: [{
          required: true,
          message: '字体颜色不可为空'
        }],
        icon_style: [{
          required: true,
          message: '图标样式不可为空'
        }],
        icon_size: [{
          required: true,
          message: '图标尺寸不可为空'
        }],
        icon_color: [{
          required: true,
          message: '图标颜色不可为空'
        }],
        message_change_style: [{
          required: true,
          message: '选项不可为空'
        }],
        message_speed: [{
          type: 'number',
          message: '速度必须为数字值'
        }],
        no_message_style: [{
          required: true,
          message: '选项不可为空'
        }],
        default_message: [{
          required: true,
          message: '文案不可为空'
        }],
        margin_top: [{
          type: 'number',
          message: '间距必须为数字值'
        }],
        z_index: [{
          required: true,
          pattern: /^(?:[1-9]|[1-9][0-9])$/,
          message: '请输入1-99之间的整数！'
        }]
      }
    };
  },
  methods: {
    changeIconStyle: function changeIconStyle(icon) {
      this.value.config.icon_style = icon;
    }
  },
  created: function created() {
    var _this$value$config = this.value.config,
      _this$value$config$ba = _this$value$config.background_color,
      background_color = _this$value$config$ba === void 0 ? '#FFFBEA' : _this$value$config$ba,
      _this$value$config$fo = _this$value$config.font_size,
      font_size = _this$value$config$fo === void 0 ? 28 : _this$value$config$fo,
      _this$value$config$fo2 = _this$value$config.font_color,
      font_color = _this$value$config$fo2 === void 0 ? '#dd722e' : _this$value$config$fo2,
      _this$value$config$ic = _this$value$config.icon_style,
      icon_style = _this$value$config$ic === void 0 ? this.iconStyleList[0] : _this$value$config$ic,
      _this$value$config$ic2 = _this$value$config.icon_size,
      icon_size = _this$value$config$ic2 === void 0 ? 40 : _this$value$config$ic2,
      _this$value$config$ic3 = _this$value$config.icon_color,
      icon_color = _this$value$config$ic3 === void 0 ? '#dd722e' : _this$value$config$ic3,
      _this$value$config$me = _this$value$config.message_change_style,
      message_change_style = _this$value$config$me === void 0 ? '1' : _this$value$config$me,
      _this$value$config$me2 = _this$value$config.message_speed,
      message_speed = _this$value$config$me2 === void 0 ? 120 : _this$value$config$me2,
      _this$value$config$no = _this$value$config.no_message_style,
      no_message_style = _this$value$config$no === void 0 ? '1' : _this$value$config$no,
      _this$value$config$de = _this$value$config.default_message,
      default_message = _this$value$config$de === void 0 ? '暂无消息' : _this$value$config$de,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      background_color: background_color,
      font_size: font_size,
      font_color: font_color,
      icon_style: icon_style,
      icon_size: icon_size,
      icon_color: icon_color,
      message_change_style: message_change_style,
      message_speed: message_speed,
      no_message_style: no_message_style,
      default_message: default_message,
      margin_top: margin_top,
      z_index: z_index
    }));
  }
};